import React from 'react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import PropTypes from 'prop-types';
import Event from './Event';

const localizer = BigCalendar.momentLocalizer(moment); // or globalizeLocalizer

function CalendarComponent({ onSelectEvent, data }) {
  const onSelect = e => {
    if (onSelectEvent) {
      onSelectEvent(e);
    }
  };
  return (
    <div style={{ height: '600px', padding: '20px' }}>
      <BigCalendar
        popup
        defaultDate={new Date()}
        events={data}
        components={{
          event: Event(0),
        }}
        showMultiDayTimes
        localizer={localizer}
        views={['month']}
        onSelectEvent={onSelect}
      />
    </div>
  );
}

CalendarComponent.propTypes = {
  onSelectEvent: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarComponent;
